import { StyledButton, StyledModal } from "@aureskonnect/react-ui";
import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";
import { FaSync } from "react-icons/fa";
import { ModalBody } from "reactstrap";

import {
    setIsSyncConfirmationModalWrapperOpened,
    setIsSyncProgressModalWrapperOpened,
    syncStore,
} from "@components/Synchronization/store";

import {
    kioskStore,
    setLocalProject,
    setProject,
    setSelectedSaleModeOrderTaking,
} from "@pages/Kiosk/store";

import "./index.css";

export function SyncConfirmationModalWrapper(): JSX.Element {
    const {
        isSyncConfirmationModalWrapperOpened,
        selectedEntity,
        selectedEntityChild,
        selectedShopApp,
    } = useSnapshot(syncStore);
    const { isLocalConfigModalOpened } = useSnapshot(kioskStore);

    async function handleSyncButtonOnClickEvent() {
        // Set fidelity type from shop app if not defined in project
        const project = { ...(selectedShopApp.project as ProjectType) };
        if (!project.fidelityType) {
            project.fidelityType = selectedShopApp.fidelityType as number;
        }
        setProject(project);
        if (
            ((
                (selectedShopApp.project as ProjectType).template.pages.ways[
                    "salesMethods"
                ] as PageType
            ).skipped as boolean) === true
        ) {
            const activeSalesMode = (
                (selectedShopApp.project as ProjectType).template.content
                    .salesMethods as ProjectContentItemType
            ).items.filter((item) => item.active === true);
            if (activeSalesMode.length === 1) {
                setSelectedSaleModeOrderTaking(
                    activeSalesMode[0].settingKey as string
                );
            }
        }
        if (isLocalConfigModalOpened) {
            setLocalProject(selectedShopApp.project as ProjectType);
        }

        const franchiseId =
            selectedEntity?.schema !== "" &&
            selectedEntity?.uid === selectedEntityChild?.franchiseUuid
                ? selectedEntity?.schema
                : selectedEntityChild?.schema;
        const shopId = selectedEntityChild?.id;

        const newShopDetail = {
            schema: franchiseId,
            id: shopId,
            franchise_uid: selectedEntityChild?.franchiseUuid,
            shop_uid: selectedEntityChild?.uid,
            uid_franchise_database_info:
                selectedEntity?.franchiseUuidDatabaseInfo,
        };

        localStorage.setItem("shopDetail", JSON.stringify(newShopDetail));

        setIsSyncConfirmationModalWrapperOpened(false);
        setIsSyncProgressModalWrapperOpened(true);
    }

    function handleChooseAnotherAppButtonClickEvent(): void {
        setIsSyncConfirmationModalWrapperOpened(false);
    }

    return (
        <StyledModal
            backdrop={false}
            centered={true}
            className="sync-confirmation-modal__clz"
            isOpen={isSyncConfirmationModalWrapperOpened}
        >
            <ModalBody
                className="d-flex align-items-center justify-content-around flex-column"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "0px",
                    color: "black",
                    height: "auto",
                    maxHeight: "100vh",
                    maxWidth: "100vw",
                    zIndex: 2,
                    backgroundColor: "#FFFFFF",
                    border: "none",
                    borderRadius: "20px",
                    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                    bottom: "unset",
                    top: "unset",
                    right: "unset",
                    left: "unset",
                    overflowX: "hidden",
                    overflowY: "auto",
                    textAlign: "center",
                }}
            >
                {/* Animated Sync Icon */}
                <div
                    style={{
                        height: "120px",
                        width: "120px",
                        marginBottom: "2rem",
                        borderRadius: "50%",
                        background:
                            "linear-gradient(135deg, #077dbc 0%, #075d9b 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        boxShadow: "0 10px 25px -5px rgba(7, 125, 188, 0.3)",
                    }}
                >
                    {/* Animated Border */}
                    <div
                        style={{
                            position: "absolute",
                            top: "-8px",
                            left: "-8px",
                            right: "-8px",
                            bottom: "-8px",
                            border: "2px solid transparent",
                            borderTop: "2px solid #65b6d5",
                            borderRadius: "50%",
                            animation: "syncCycleRotate 3s linear infinite",
                        }}
                    />

                    {/* Center Icon */}
                    <div
                        style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <FaSync
                            style={{
                                fontSize: "48px",
                                color: "#ffffff",
                                animation: "syncPulse 2s ease-in-out infinite",
                            }}
                        />
                    </div>
                </div>

                {/* Title */}
                <h1
                    style={{
                        font: "normal 28px/34px Segoe UI",
                        fontWeight: 600,
                        marginBottom: "1rem",
                    }}
                >
                    {t(
                        "Do you want to synchronize this station With the kiosk application ?",
                        { name: selectedEntityChild?.name }
                    )}
                </h1>

                {/* Buttons */}
                <div
                    style={{
                        display: "flex",
                        gap: "16px",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        marginTop: "2rem",
                    }}
                >
                    <StyledButton
                        rounded={true}
                        className="text-uppercase"
                        style={{
                            width: "291px",
                            height: "60px",
                            fontSize: "16px",
                            fontWeight: "500",
                            borderRadius: "12px",
                            backgroundColor: "#ffffff",
                            border: "2px solid #e5e7eb",
                            color: "#374151",
                            boxShadow:
                                "0 10px 25px -5px rgba(85, 115, 153, 0.1)",
                            transition: "all 0.2s ease",
                        }}
                        onClick={handleChooseAnotherAppButtonClickEvent}
                    >
                        {t("Choose another application")}
                    </StyledButton>

                    <StyledButton
                        rounded={true}
                        className="text-uppercase"
                        style={{
                            width: "240px",
                            height: "60px",
                            fontSize: "16px",
                            fontWeight: "600",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "12px",
                            borderRadius: "12px",
                            border: "none",
                            background:
                                "linear-gradient(135deg, #077dbc 0%, #075d9b 100%)",
                            color: "#ffffff",
                            boxShadow:
                                "0 10px 25px -5px rgba(85, 115, 153, 0.4)",
                            transition: "all 0.2s ease",
                        }}
                        onClick={handleSyncButtonOnClickEvent}
                    >
                        {t("Synchronize")}
                    </StyledButton>
                </div>

                {/* Animations */}
                <style>{`
            @keyframes syncCycleRotate {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `}</style>
            </ModalBody>
        </StyledModal>
    );
}
